import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import useFetch from 'use-http';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import DocumentManagement from 'src/components/layout/DocumentManagement';
import DialogList from 'src/dialogs';
import Project from 'src/models/Project';
import './ProjectDetails.scss';
import ProjectDetailsModel from 'src/models/projectSettings/ProjectDetails';
import User from 'src/models/User';

interface IProjectDetailsProps {
    showDialog: (dialogName: string) => void;
    hideDialog: () => void;
}

const ProjectDetails = (props: IProjectDetailsProps) => {
    const { register, handleSubmit, errors, reset } = useForm();
    // const dispatch = useDispatch();
    const { get, response, post, put } = useFetch();
    const appContext = useContext<IAppContextState>(AppContext);

    const [formData, setFormData] = useState(null);
    const [projectData, setProjectData] = useState<Project>(undefined);
    const [users, setUsers] = useState<User[]>([]);
    const [projectDetailsData, setProjectDetailsData] = useState<ProjectDetailsModel>(undefined);

    useEffect(() => {
        getProjectData();
        getProjectDetialsData();
        getUsers();
    }, []);

    useEffect(() => {
        prepData();
    }, [projectData, projectDetailsData]);

    useEffect(() => {
        reset(formData);
    }, [formData]);

    // Pre-filled project data
    const getProjectData = async () => {
        const result = await get(`v1.0/clients/${appContext.clientNumber}/Projects/${appContext.projectNumber}`);

        if (response.ok) {
            setProjectData(result);
        } else {
            console.log('Unable to retrieve Project data');
        }
    };

    const getProjectDetialsData = async () => {
        const result = await get(`/v1.0/clients/${appContext.clientNumber}/Projects/${appContext.projectNumber}/project-details/`);

        if (response.ok) {
            setProjectDetailsData(result);
        } else {
            console.log('Unable to retrieve Project Details data');
        }
    };

    const getUsers = async () => {
        const result = await get(`/v1.0/users`);

        if (response.ok) {
            setUsers(result.items);
        } else {
            console.log('Unable to retrieve Users data.');
        }
    };

    const prepData = () => {
        let newFormData: ProjectDetailsModel = {
            id: projectDetailsData ? projectDetailsData?.id : 0,
            name: projectData ? projectData?.name : '',
            projectType: projectData ? projectData?.projectType.name : '',
            clientReferenceNo: projectData ? projectData?.client?.id : null,
            afeNumber: projectDetailsData ? projectDetailsData?.afeNumber : 0,
            mileageRate: projectDetailsData ? projectDetailsData?.mileageRate : 0,
            projectManagerId: projectDetailsData ? projectDetailsData?.projectManagerId : 0,
            pcapmId: projectDetailsData ? projectDetailsData?.pcapmId : 0,
            clientContact: projectDetailsData ? projectDetailsData?.clientContact : '',
            bdPersonnel: projectDetailsData ? projectDetailsData?.bdPersonnel : '',
            originatingOffice: projectDetailsData ? projectDetailsData?.originatingOffice : '',
            hideOnInvoice: projectDetailsData ? projectDetailsData?.hideOnInvoice : '',
            district: projectDetailsData ? projectDetailsData?.district : '',
            project: projectDetailsData ? projectDetailsData?.project : '',
            wellName: projectDetailsData ? projectDetailsData?.wellName : '',
            pcapmProdBonusLevel: projectDetailsData ? projectDetailsData?.pcapmProdBonusLevel : '',
            asrExpenses: projectDetailsData ? projectDetailsData?.asrExpenses : 0,
        };

        setFormData(newFormData);
    };

    const createRecord = async (data: ProjectDetailsModel) => {
        const result = await post(`/v1.0/clients/${appContext.clientNumber}/Projects/${appContext.projectNumber}/project-details/`, data);

        if (response.ok) {
            console.log('Successfully created a project detials record', result);
        }
        console.log('project details');
    };

    const updateRecord = async (data: ProjectDetailsModel) => {
        const result = await put(`/v1.0/clients/${appContext.clientNumber}/Projects/${appContext.projectNumber}/project-details/`, data);

        if (response.ok) {
            console.log('result', result);
            getProjectDetialsData();
        }

        console.log('project details');
    };

    const findUserRole = (x: number) => {
        let correctUsers = users
            .filter((u: User) => u?.role?.id === x)
            .map((u) => {
                return {
                    value: u.id,
                    label: `${u.firstName} ${u.lastName}`,
                };
            });
        return correctUsers ? correctUsers : [];
    };

    const filesUploded = () => {
        props.hideDialog();
        console.log('Testing!!');
    };

    const formatValues = (values: ProjectDetailsModel) => {
        let newValues: ProjectDetailsModel = {
            id: 0,
            name: '',
            afeNumber: 0,
            mileageRate: 0,
            clientReferenceNo: 0,
            projectManagerId: 0,
            pcapmId: 0,
            clientContact: '',
            bdPersonnel: '',
            originatingOffice: '',
            hideOnInvoice: '',
            district: '',
            project: '',
            wellName: '',
            projectType: '',
            pcapmProdBonusLevel: '',
            asrExpenses: 0,
        };

        newValues.id = projectDetailsData.id ? parseInt(projectDetailsData.id + '', 10) : 0;
        newValues.afeNumber = values.afeNumber ? parseInt(values.afeNumber + '', 10) : 0;
        newValues.mileageRate = values.mileageRate ? parseInt(values.mileageRate + '', 10) : 0;
        newValues.clientReferenceNo = values.clientReferenceNo ? parseInt(values.clientReferenceNo + '', 10) : 0;
        newValues.asrExpenses = values.asrExpenses ? parseFloat(values.asrExpenses + '') : 0;
        newValues.name = values.name ? values.name : '';
        newValues.projectManagerId = values.projectManagerId ? parseInt(values.projectManagerId + '', 10) : 0;
        newValues.pcapmId = values.pcapmId ? parseInt(values.pcapmId + '', 10) : 0;
        newValues.clientContact = values.clientContact ? values.clientContact : '';
        newValues.bdPersonnel = values.bdPersonnel ? values.bdPersonnel : '';
        newValues.originatingOffice = values.originatingOffice ? values.originatingOffice : '';
        newValues.hideOnInvoice = values.hideOnInvoice ? values.hideOnInvoice : '';
        newValues.district = values.district ? values.district : '';
        newValues.project = values.project ? values.project : '';
        newValues.wellName = values.wellName ? values.wellName : '';
        newValues.projectType = values.projectType ? values.projectType : '';
        newValues.pcapmProdBonusLevel = values.pcapmProdBonusLevel ? values.pcapmProdBonusLevel : '';

        return newValues;
    };

    const onSubmit = (values: ProjectDetailsModel) => {
        let newValues = formatValues(values);

        console.log('values after sanitizing', newValues);

        if (!projectDetailsData.id) {
            createRecord(newValues);
        } else {
            updateRecord(newValues);
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="flex space__btw" style={{ alignItems: 'center' }}>
                    <div className="flex" style={{ marginBottom: '3rem', gap: '3rem' }}>
                        <div className="flex gap_2" style={{ flexWrap: 'wrap' }}>
                            {/* <div className="input-width">
                                        <RHFInputBox name="name" label="Name" register={register} errors={errors} />
                                    </div> */}
                            <div className="input-width">
                                <RHFInputBox name="afeNumber" label="AFE No." register={register} errors={errors} />
                            </div>
                            <div className="input-width">
                                <RHFInputBox name="mileageRate" label="Mileage Rate" register={register} errors={errors} />
                            </div>
                            <div className="input-width">
                                <RHFInputBox
                                    name="clientReferenceNo"
                                    label="Client Reference No."
                                    register={register}
                                    errors={errors}
                                    disabled={true}
                                />
                            </div>
                            {/* </div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', width: '50%', gap: '2rem' }}> */}
                            <div className="input-width">
                                <RHFSelect label="PCAPM" name="projectManagerId" options={findUserRole(3)} register={register} errors={errors} />
                            </div>
                            {/* <div className="input-width">
                                        <RHFSelect label="PC/APM" name="pcapmId" options={findUserRole(3)} register={register} errors={errors} />
                                    </div> */}
                            <div className="input-width">
                                <RHFInputBox name="clientContact" label="Client Contact" register={register} errors={errors} />
                            </div>
                            <div className="input-width">
                                <RHFInputBox name="bdPersonnel" label="BD Personnel" register={register} errors={errors} />
                            </div>
                            <div className="input-width">
                                <RHFSelect
                                    label="Hide on Invoice?"
                                    name="hideOnInvoice"
                                    options={[
                                        { value: 'semiMonthly', label: 'Do not Hide' },
                                        { value: 'monthly', label: 'Hide' },
                                    ]}
                                    register={register}
                                    errors={errors}
                                />
                            </div>
                            <div className="input-width">
                                <RHFInputBox name="district" label="District" register={register} errors={errors} />
                            </div>
                            <div className="input-width">
                                <RHFInputBox name="project" label="Project" register={register} errors={errors} />
                            </div>
                            <div className="input-width">
                                <RHFInputBox name="wellName" label="Well Name" register={register} errors={errors} />
                            </div>
                            {/* <div className="input-width">
                            <RHFInputBox name="projectType" label="Project Type" register={register} errors={errors} />
                        </div> */}
                            <div className="input-width">
                                <RHFSelect
                                    label="PC/APM Prod. Bonus Level"
                                    name="pcapmProdBonusLevel"
                                    options={[
                                        { value: 'prospect', label: 'Prospect' },
                                        { value: 'section', label: 'Section' },
                                        { value: 'unit', label: 'Unit' },
                                    ]}
                                    register={register}
                                />
                            </div>
                            <div className="input-width">
                                <RHFInputBox name="asrExpenses" label="ASR Beginning Services/Expenses" register={register} errors={errors} />
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="flex gap_2 borderBtmSG paddingTop paddingBtm"
                    style={{ flexWrap: 'wrap', margin: '1rem 0 2.5rem', borderTop: 'none' }}
                >
                    {/* <div className="input-width">
                            <RHFInputBox name="originatingOffice" label="Orginating Office" register={register} errors={errors} />
                        </div> */}

                    <div className="input-width">
                        <Button className="blue-hover-button" text="Attach Documents" intent="secondary" onClick={() => props.showDialog(DialogList.DOCUMENT_MANAGEMENT)} />
                    </div>
                </div>

                <div className="marginTop">
                    <Button text="Submit" intent="primary" type="submit" />
                </div>
            </form>
            <DocumentManagement filesUploaded={filesUploded} context="project details" />
        </div>
    );
};

export default ProjectDetails;



// WEBPACK FOOTER //
// ./src/components/project/sections/ProjectDetails.tsx